import React from 'react'
import aboutImage from '../../assets/images/Employee.jpg'
import PageCreator from '../../components/PageCreator'
import '../../assets/scss/index.scss'

import {Container, Col, Row } from 'react-bootstrap'
export default function index() {
    return (
        <PageCreator imageName={aboutImage} opacityLevel='0.9'>
        <p className='mainFont' style={{ color: "#222222", fontSize: '1.5em', margin: '0' }}>Employee Section</p>

        <hr style={{ backgroundColor: "#222222" }} />
        <Container>
            <Row>
                <Col>
                Important Employee Links:<br />
                <ul>
                    <br />
                    <li style={{marginLeft: '70px'}}><a href="https://doc5.carehawaii.com/owa" target="_blank" rel="noopener noreferrer">Outlook Portal</a></li>
                    <br />
                    <li style={{marginLeft: '70px'}}><a href="https://care.ehana.com" target="_blank" rel="noopener noreferrer">Ehana Portal</a></li>
                </ul>
                <br />
                <br />
                </Col>
            </Row>
        </Container>

    </PageCreator>
    )
}
